import Switch from './Switch';

export default Switch;



// WEBPACK FOOTER //
// ./src/components/shared/Switch/index.jsx